import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ApiServiceService } from 'src/app/Services/api-service.service';
import { ErrorDialogComponent } from '../../error-dialog/error-dialog.component';
import { SuccessDialogComponent } from '../../success-dialog/success-dialog.component';
import * as alertify from 'alertifyjs';
import { ConfirmDialogComponent } from '../../confirm-dialog/confirm-dialog.component';
import { Location } from '@angular/common';
import { QueryModalComponent } from '../../query-modal/query-modal.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CardType, PrintDto } from 'src/app/models/printDto';
import { DownloadService } from 'src/app/Services/app-service/download.service';

@Component({
  selector: 'app-da-demand-notice',
  templateUrl: './da-demand-notice.component.html',
  styleUrls: ['./da-demand-notice.component.css']
})
export class DaDemandNoticeComponent implements OnInit {

  assessmentId: any;
  details: any;
  expiryYear: any
  form: FormGroup;
  isLoading: boolean | undefined;
  isEmpty: boolean | undefined;
  
    constructor(
    private route: ActivatedRoute,
    private apiService: ApiServiceService,
    private bsModalService: BsModalService,
    private location: Location,
    private router: Router,
    private fb: FormBuilder,
    private downloadService: DownloadService
    ) {
      this.form = this.fb.group({
        assessmentId: [''],
        type: ['APPROVED'],
      });
     }
  
    ngOnInit(): void {
      
      this.route.params.subscribe(params => {
        this.assessmentId = params['assessmentId'];
      });
      this.getDirectAssessment();
    }


    download(id:any){
      const dto:PrintDto = {
        id: id,
        type: CardType.DIRECT_ASSESSMENT
      }

      const dtos:PrintDto[] = new Array<PrintDto>();
      dtos.push(dto)

      const url = "/assessments/downloads/assessments";
      this.apiService.post(url, dtos).subscribe(
        (response) => {
          this.downloadService.download(response)
        },
        (error) => {
          console.log(error);
        }
      );
      
    }

    getDirectAssessment(){
      this.isLoading = true;
      this.isEmpty = false;
      const url = `/assessments/view/directAssessment/${this.assessmentId}`;
      this.apiService.get(url).subscribe(
        (response) => {
         
          this.details = response.data;
          var filingDate = new Date(this.details.filingDate);
          this.expiryYear = filingDate.getFullYear();
          this.isLoading = false
          this.isEmpty = false;
        },
        (error) => {
          console.log(error);
          this.isLoading = false;
          this.isEmpty = true;
        }
      );
    }

    confirmApprove() {
      let dfModalRef = this.bsModalService.show(ConfirmDialogComponent, {
        initialState: {
          body: "Are you sure you want to approve this assessment?"
        },
        class: "modal-sm modal-dialog-centered",
      });
      dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
        this.approve();
  
        dfModalRef.hide();
      });
    }

    query(){

      let dfModalRef = this.bsModalService.show(QueryModalComponent, {
        initialState: {
          body: "Are you sure you want to approve this assessment?",
          assessmentId: this.assessmentId
        },
        class: "modal-sm modal-dialog-centered",
      });
      dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
        this.approve();
  
        dfModalRef.hide();
      });

    }
  
  
    approve(){
  
      let url = "/assessments/query"

      this.form.patchValue({'assessmentId': this.assessmentId})
  
      this.apiService.post(url, this.form.value).subscribe(
        (response) => {
          
          alertify.set("notifier", "position", "top-center");
          alertify.success("Assessment approved successfully");

          this.goBack()
          
        },
        (error) => {
         
          this.confirmAfterError("Action was not successful");
          alertify.set("notifier", "position", "top-center");
          alertify.error("Error performing this operation");
          
        }
      );
    }

    goBack() {
      this.location.back();
    }
  
    confirmAfterSuccess(message: any) {
      let dfModalRef = this.bsModalService.show(SuccessDialogComponent, {
        initialState: {
          body: message,
        },
        class: "modal-sm modal-dialog-centered",
      });
      dfModalRef?.content?.onConfirmClicked.subscribe((v) => {

        dfModalRef.hide();
        
      });

      this.goBack()
    }
  
    
  
    confirmAfterError(message: any) {
      let dfModalRef = this.bsModalService.show(ErrorDialogComponent, {
        initialState: {
          body: message,
        },
        class: "modal-sm modal-dialog-centered",
      });
      dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
        dfModalRef.hide();
      });
    }


    downloadNotice(){

      let url = "/assessments/get/demand-notice-assessment";

      let dto = this.details;
      
      dto.expiryYear = this.expiryYear;
      dto.assessmentId = this.assessmentId;
      let filingDate = new Date(dto.filingDate);
      let filingDateStr = `${filingDate.getDate()}/${filingDate.getMonth() + 1}/${filingDate.getFullYear()}`;
      dto.filingDate = filingDateStr; 
  
  
    this.apiService.post(url, dto, { responseType: 'blob' }).subscribe(
      (response: Blob) => {
  
        const blob = new Blob([response], { type: 'application/pdf' });
  
        // Create a Blob URL for the PDF content
        const blobUrl = window.URL.createObjectURL(blob);
  
        // Open PDF in a new tab
        // window.open(blobUrl, '_blank');
  
        const file = new Blob([response], { type: 'application/pdf' });
  
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
  
        // Optionally, trigger a download by creating an anchor element
        const downloadLink = document.createElement('a');
        downloadLink.href = blobUrl;
        downloadLink.target = '_blank';
        downloadLink.download = dto?.asin +'_demand_notice.pdf';// File name for download
  
        // Uncomment this line to trigger the download automatically
        downloadLink.click();
  
        alertify.set("notifier", "position", "top-center");
        alertify.success("Download successful");
      },
      (error) => {
        this.isLoading = false;
        alertify.set("notifier", "position", "top-center");
        alertify.error("Error performing this operation");
        this.isEmpty = true;
      }
    );
    }


}
